export default __webpack_public_path__ + "static/pyramid-60c68e4d334d10534ce2412a827b480f.gif";